export default __webpack_public_path__ + "static/media/th_TH.4b4adc87.svg";